module.exports = __webpack_public_path__ + "img/f4-3.e7cbaec2.jpg";